import { ApiClient } from '../config';

const apiClient = new ApiClient();

export interface Role {
  roleId: string;
  name: string;
  description: string;
  isSystem: boolean;
  permissions: Array<{
    resource: string;
    action: string;
  }>;
}

export interface Permission {
  resource: string;
  action: string;
}

class RBACService {
  async getAllRoles(): Promise<Role[]> {
    const response = await apiClient.get<Role[]>('/api/v1/rbac/roles');
    return response || [];
  }

  async getPermissions(): Promise<Permission[]> {
    const response = await apiClient.get<Permission[]>('/api/v1/rbac/permissions');
    return response || [];
  }

  async assignRole(userId: string, roleId: string): Promise<void> {
    await apiClient.post(`/api/v1/rbac/users/${userId}/roles/${roleId}`, {});
  }

  async revokeRole(userId: string, roleId: string): Promise<void> {
    await apiClient.delete(`/api/v1/rbac/users/${userId}/roles/${roleId}`);
  }

  async getUserRoles(userId: string): Promise<Role[]> {
    const response = await apiClient.get<Role[]>(`/api/v1/rbac/users/${userId}/roles`);
    return response || [];
  }
}

export const rbacService = new RBACService();